// ---------------------------------------------------------------------------
// PropertyMetadataRegistry — TS-side placeholder for Sub-project B PR4 InspectorOverlay.
//
// Minimal registry stub. The Flutter pattern at
// creatego_interface/lib/src/widgets/shadcn_widgets/ has no TS equivalent in
// cogo-web yet. PR5+ may wire this to existing page-editor property sections,
// or metadata may flow from server-side schemas.
//
// For PR4, this stub returns null for unknown types and minimal metadata for
// 3 demo types so the InspectorOverlay can be smoke-tested.
// ---------------------------------------------------------------------------

export interface PropertyMetadata {
  key: string
  type: 'string' | 'number' | 'boolean' | 'enum'
  label?: string
  enumValues?: string[]
}

export interface ComponentMetadata {
  properties: PropertyMetadata[]
}

const DEMO_REGISTRY: Record<string, ComponentMetadata> = {
  button: {
    properties: [
      { key: 'text', type: 'string', label: 'Text' },
      { key: 'variant', type: 'enum', label: 'Variant', enumValues: ['default', 'outline', 'ghost'] },
      { key: 'disabled', type: 'boolean', label: 'Disabled' },
    ],
  },
  text: {
    properties: [
      { key: 'content', type: 'string', label: 'Content' },
      { key: 'variant', type: 'enum', label: 'Variant', enumValues: ['body', 'heading', 'caption'] },
    ],
  },
  container: {
    properties: [
      { key: 'padding', type: 'number', label: 'Padding' },
      { key: 'background', type: 'string', label: 'Background' },
    ],
  },
}

export const PropertyMetadataRegistry = {
  get(componentType: string): ComponentMetadata | null {
    return DEMO_REGISTRY[componentType] ?? null
  },
}
